import * as THREE from 'three';
import { PuzzleElement } from './PuzzleElement';

export class WaterZone extends PuzzleElement {
  private size: THREE.Vector3;
  private waterLevel: number;
  private boundingBox: THREE.Box3;
  
  constructor(position: THREE.Vector3, size: THREE.Vector3) {
    super(position);
    this.size = size.clone();
    this.waterLevel = position.y + size.y / 2;
    
    // Update mesh size
    (this.mesh as THREE.Mesh).geometry.dispose();
    (this.mesh as THREE.Mesh).geometry = new THREE.BoxGeometry(size.x, size.y, size.z);
    
    this.boundingBox = new THREE.Box3(
      new THREE.Vector3(
        position.x - size.x / 2,
        position.y - size.y / 2,
        position.z - size.z / 2
      ),
      new THREE.Vector3(
        position.x + size.x / 2,
        position.y + size.y / 2,
        position.z + size.z / 2
      )
    );
  }
  
  protected createMesh(): THREE.Mesh {
    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshStandardMaterial({ 
      color: 0x0077be,
      transparent: true,
      opacity: 0.6,
      roughness: 0.1,
      metalness: 0.3
    });
    
    const mesh = new THREE.Mesh(geometry, material);
    mesh.receiveShadow = true;
    
    return mesh;
  }
  
  public update(deltaTime: number, _playerPosition: THREE.Vector3): void {
    // Animate water surface
    const time = Date.now() * 0.001;
    this.mesh.position.y = this.position.y + Math.sin(time * 2) * 0.05;
  }
  
  public containsPoint(point: THREE.Vector3): boolean {
    return this.boundingBox.containsPoint(point);
  }
  
  public getWaterLevel(): number {
    return this.waterLevel;
  }
  
  public isUnderwater(point: THREE.Vector3): boolean {
    return this.containsPoint(point) && point.y < this.waterLevel;
  }
}
